import React from "react";
import AuthenticationButton from "./authentication-button";

const AuthNav = () => (
  <div className="navbar-nav ml-0">
    <AuthenticationButton />
  </div>
);

export default AuthNav;